const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

const fullNumberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

export function formatCompactNumber(value?: number | null) {
  if (value == null || Number.isNaN(value)) {
    return "";
  }

  if (Math.abs(value) < 1000) {
    return fullNumberFormatter.format(value);
  }

  return compactNumberFormatter.format(value);
}

export function formatFullNumber(value?: number | null) {
  if (value == null || Number.isNaN(value)) {
    return "";
  }

  return fullNumberFormatter.format(value);
}
